import { PlaylistAddCheck } from '@mui/icons-material';
import { Grid, IconButton, Slide } from '@mui/material';
import moment from 'moment';
import React from 'react';

import { TableReload } from '#app/Action/TableAction';
import { dispatch } from '#app/App';
import { cacheTablePage, cacheTableServer } from '#app/Cache';
import ContentViewComponent from '#app/Component/ContentViewComponent';
import IconAction from '#app/Component/IconAction';
import SelectComponent from '#app/Component/SelectComponent';
import ShadowBoxComponent from '#app/Component/ShadowBoxComponent';
import TableComponent from '#app/Component/TableComponent';
import TextFieldComponent from '#app/Component/TextFieldComponent';
import TitleComponent from '#app/Component/TitleComponent';
import ApiHandler from '#app/Handler/ApiHandler';
import { initFormHandler } from '#app/Handler/FormHandler';
import ReceiveModal from '#app/View/InventoryManagement/ReturnOrder/ReceiveModal';
import ReturnModal from '#app/View/InventoryManagement/ReturnOrder/ReturnModal';
import { ChannelSelects } from '#app/typings/channel';
import { OrderClientStateSelects, OrderClientStateTranslation } from '#app/typings/orderClient';
import { DisputeStateSelects, DisputeStateTranslations } from '#app/typings/orderClientLitige';

function InventoryManagementReturnOrder() {
  const [openDialog, setOpenDialog] = React.useState(false);
  const [openDialogReceive, setOpenDialogReceive] = React.useState(false);
  const [litigeUuid, setLitigeUuid] = React.useState();

  const columns = [
    {
      name: 'number',
      label: 'Référence',
      options: { filter: true, sort: true },
    },
    {
      name: 'clientEmail',
      label: 'Email',
      options: { filter: true, sort: true },
    },
    {
      name: 'clientName',
      label: 'Client',
      options: { filter: true, sort: true },
    },
    {
      name: 'channel',
      label: 'Canal',
      options: { filter: true, sort: true },
    },
    {
      name: 'orderClientState',
      label: 'Etat',
      options: { filter: true, sort: true },
    },
    {
      name: 'disputeState',
      label: 'Etat du litige',
      options: { filter: true, sort: true },
    },
    {
      name: 'reason',
      label: 'Raison du litige',
      options: { filter: true, sort: true },
    },
    {
      name: 'author',
      label: 'Auteur du litige',
      options: { filter: true, sort: true },
    },
    {
      name: 'createdAt',
      label: 'Date de la commande',
      options: { filter: true, sort: true },
    },
    {
      name: 'litigeAt',
      label: 'Date de litige',
      options: { filter: true, sort: true },
    },
    {
      name: 'dealAt',
      label: 'Date de cloture',
      options: { filter: true, sort: true },
    },
    {
      name: 'returnAt',
      label: 'Date de réception',
      options: { filter: true, sort: true },
    },
    {
      name: 'authorReturn',
      label: 'Réceptionné par',
      options: { filter: true, sort: true },
    },
    {
      name: 'action',
      label: 'Action',
      options: { filter: false, sort: false },
    },
  ];

  const [formSearch, setFormSearch] = React.useState({
    number: {
      name: 'number',
      label: 'Référence',
      textHelper: 'Rechercher par référence.',
      type: 'text',
      defaultValue:
        cacheTableServer['api_inventory_management_return_order_list'] &&
        cacheTableServer['api_inventory_management_return_order_list'].number
          ? cacheTableServer['api_inventory_management_return_order_list'].number
          : '',
    },
    clientEmail: {
      name: 'clientEmail',
      label: 'Email',
      textHelper: 'Rechercher par email.',
      type: 'text',
      defaultValue:
        cacheTableServer['api_inventory_management_return_order_list'] &&
        cacheTableServer['api_inventory_management_return_order_list'].clientEmail
          ? cacheTableServer['api_inventory_management_return_order_list'].clientEmail
          : '',
    },
    clientName: {
      name: 'clientName',
      label: 'Client',
      textHelper: 'Rechercher par client.',
      type: 'text',
      defaultValue:
        cacheTableServer['api_inventory_management_return_order_list'] &&
        cacheTableServer['api_inventory_management_return_order_list'].clientName
          ? cacheTableServer['api_inventory_management_return_order_list'].clientName
          : '',
    },
    channel: {
      name: 'channel',
      label: 'Canal',
      textHelper: 'Rechercher par canaux.',
      type: 'integer',
      defaultValue:
        cacheTableServer['api_inventory_management_return_order_list'] &&
        cacheTableServer['api_inventory_management_return_order_list'].channel
          ? cacheTableServer['api_inventory_management_return_order_list'].channel
          : 0,
    },
    orderClientState: {
      name: 'orderClientState',
      label: 'État',
      textHelper: 'Rechercher par état.',
      type: 'integer',
      defaultValue:
        cacheTableServer['api_inventory_management_return_order_list'] &&
        cacheTableServer['api_inventory_management_return_order_list'].orderClientState
          ? cacheTableServer['api_inventory_management_return_order_list'].orderClientState
          : 0,
    },
    disputeState: {
      name: 'disputeState',
      label: 'État litige',
      textHelper: 'Rechercher par état de litige.',
      type: 'text',
    },
  });

  const handlerFormSearch = initFormHandler(formSearch, setFormSearch);

  const inputSearchChange = (index, value) => {
    handlerFormSearch.setValue(index, value);
    cacheTablePage.api_inventory_management_return_order_list = 0;
    cacheTableServer.api_inventory_management_return_order_list.page = 0;
    cacheTableServer.api_inventory_management_return_order_list[index] = value;
    dispatch(TableReload('api_inventory_management_return_order_list'));
  };

  const getAction = (row) => (
    <>
      {!row.returnAt ? (
        <IconAction
          title="Réceptionner"
          icon="check"
          onClick={() => {
            setOpenDialogReceive(true);
            setLitigeUuid(row.orderClientLitigeUuid);
          }}
        />
      ) : (
        <IconButton style={{ cursor: 'no-drop' }}>
          <PlaylistAddCheck />
        </IconButton>
      )}
    </>
  );

  React.useEffect(() => {
    handlerFormSearch.start();
  }, []);

  return (
    <ContentViewComponent breadcrumbs={{ title: 'Retour Commande', context: 'Gestion des stocks' }}>
      <Slide direction="left" in timeout={750}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <ShadowBoxComponent>
            <TitleComponent title={'Filtres'} />
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                <TextFieldComponent
                  id={'number'}
                  handler={handlerFormSearch}
                  onChange={(val) => inputSearchChange('number', val)}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                <TextFieldComponent
                  id={'clientEmail'}
                  handler={handlerFormSearch}
                  onChange={(val) => inputSearchChange('clientEmail', val)}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                <TextFieldComponent
                  id={'clientName'}
                  handler={handlerFormSearch}
                  onChange={(val) => inputSearchChange('clientName', val)}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                <SelectComponent
                  id={'channel'}
                  options={ChannelSelects}
                  withSelectAll
                  handler={handlerFormSearch}
                  onChange={(val) => inputSearchChange('channel', val)}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                <SelectComponent
                  id={'orderClientState'}
                  options={OrderClientStateSelects}
                  withSelectAll
                  handler={handlerFormSearch}
                  onChange={(val) => inputSearchChange('orderClientState', val)}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                <SelectComponent
                  id="disputeState"
                  options={DisputeStateSelects}
                  withSelectAll
                  handler={handlerFormSearch}
                  onChange={(val) => inputSearchChange('disputeState', val)}
                />
              </Grid>
            </Grid>
          </ShadowBoxComponent>
        </Grid>
      </Slide>

      <br />

      <TableComponent
        id={'api_inventory_management_return_order_list'}
        title={'Retours commande client'}
        columns={columns}
        actionFirst={{
          label: 'Créer un retour',
          onClick: () => setOpenDialog(true),
        }}
        promiseServerData={(resolve, options) => {
          const datas = handlerFormSearch.getData();
          const filters = {
            limit: options.rowsPerPage,
            offset: options.page * options.rowsPerPage,
            sortName: options.sortOrder.name,
            sortDirection: options.sortOrder.direction,
            number: formSearch.number.value ? formSearch.number.value : '',
            clientEmail: formSearch.clientEmail.value ? formSearch.clientEmail.value : '',
            clientName: formSearch.clientName.value ? formSearch.clientName.value : '',
            channel: datas.channel === 0 || !datas.channel ? '' : datas.channel,
            orderClientState: datas.orderClientState,
            disputeState: datas.disputeState,
          };

          ApiHandler.get(
            {
              route: 'api_inventory_management_return_order_list',
              data: filters,
            },
            (response) => {
              const data = response.data ? response.data.data : [];
              for (const index in data) {
                data[index].action = getAction(data[index]);
                data[index].returnAt = data[index].returnAt ? moment(data[index].returnAt).format('lll') : '-';
                data[index].authorReturn = data[index].authorReturn ?? '-';
                data[index].createdAt = moment(data[index].createdAt).format('lll');
                data[index].dealAt = data[index].dealAt ? moment(data[index].dealAt).format('lll') : '-';
                data[index].litigeAt = moment(data[index].litigeAt).format('lll');
                data[index].number = data[index].number ?? '-';
                data[index].clientEmail = data[index].clientEmail ?? '-';
                data[index].clientName = data[index].clientName ?? '-';
                data[index].channel = data[index].channel ?? '-';
                data[index].orderClientState = OrderClientStateTranslation[data[index].orderClientState];
                data[index].disputeState = data[index].disputeState
                  ? DisputeStateTranslations[data[index].disputeState]
                  : '-';
              }
              resolve(data, response.data ? response.data.count : 0);
            },
          );
        }}
        search={false}
      />

      {openDialog && <ReturnModal onClose={() => setOpenDialog(false)} />}
      {openDialogReceive && <ReceiveModal onClose={() => setOpenDialogReceive(false)} uuid={litigeUuid} />}
    </ContentViewComponent>
  );
}

export default InventoryManagementReturnOrder;
